import _taggedTemplateLiteral from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;

import styled, { css } from 'styled-components';
import Image from 'next/legacy/image';
import Link from 'next/link';
import { Container } from '@yoweb/ui/components/containers';
import { getSpace } from '@yoweb/ui/styles/utils/theme';
import { media, pxToRem } from '@yoweb/ui/styles/utils';
import { Title } from '@yoweb/ui/components/typography';
import { Button } from '@yoweb/ui/components/buttons';
import { HEADER_HEIGHT_DESKTOP } from '@store/constants/header';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var ErrorLayout = function ErrorLayout(_ref) {
  var title = _ref.title,
      subtitle = _ref.subtitle,
      href = _ref.href,
      linkLabel = _ref.linkLabel,
      image = _ref.image,
      imageDesktop = _ref.imageDesktop,
      imageHeight = _ref.imageHeight,
      imageHeightMobile = _ref.imageHeightMobile,
      imageAltText = _ref.imageAltText,
      _ref$imageAlign = _ref.imageAlign,
      imageAlign = _ref$imageAlign === void 0 ? 'center' : _ref$imageAlign,
      _ref$isEmbedded = _ref.isEmbedded,
      isEmbedded = _ref$isEmbedded === void 0 ? false : _ref$isEmbedded;
  return /*#__PURE__*/_jsxs(StyledContainer, {
    withGrid: true,
    children: [/*#__PURE__*/_jsxs(Header, {
      hasTopPadding: !isEmbedded,
      children: [/*#__PURE__*/_jsx(Title, {
        as: "h1",
        size: {
          _: 'xl',
          lg: 'xxl'
        },
        "data-testid": "error-title",
        whiteSpace: "pre-wrap",
        children: title
      }), /*#__PURE__*/_jsx(Title, {
        as: "p",
        size: "xs",
        weight: "regular",
        "data-testid": "error-subtitle",
        children: subtitle
      }), /*#__PURE__*/_jsx(ButtonWrapDesktop, {
        children: !isEmbedded && /*#__PURE__*/_jsx(Link, {
          href: href,
          passHref: true,
          legacyBehavior: true,
          children: /*#__PURE__*/_jsx(Button, {
            as: "a",
            "data-testid": "error-link",
            children: linkLabel
          })
        })
      })]
    }), /*#__PURE__*/_jsx(ImageWrapDesktop, {
      imageAlign: imageAlign,
      children: /*#__PURE__*/_jsx(ImageHolderDesktop, {
        imageHeight: imageHeight,
        children: /*#__PURE__*/_jsx(Image, {
          src: imageDesktop,
          layout: "fill",
          objectFit: "contain",
          objectPosition: "center",
          alt: imageAltText
        })
      })
    }), /*#__PURE__*/_jsx(ImageWrapMobile, {
      imageHeightMobile: imageHeightMobile,
      children: /*#__PURE__*/_jsx(Image, {
        src: image,
        layout: "fill",
        objectFit: "contain",
        objectPosition: "bottom"
      })
    }), /*#__PURE__*/_jsx(ButtonWrapMobile, {
      children: !isEmbedded && /*#__PURE__*/_jsx(Link, {
        href: href,
        passHref: true,
        legacyBehavior: true,
        children: /*#__PURE__*/_jsx(Button, {
          as: "a",
          children: linkLabel
        })
      })
    })]
  });
};
var StyledContainer = styled(Container).withConfig({
  componentId: "sc-1tjh3df-0"
})(["&&{overflow-x:hidden;min-height:100vh;}"]);
var Header = styled.div.withConfig({
  componentId: "sc-1tjh3df-1"
})(["display:grid;grid-column:1/5;grid-auto-rows:min-content;max-width:", ";row-gap:", ";", " ", " ", ""], pxToRem(524), getSpace('normal1'), function (_ref2) {
  var hasTopPadding = _ref2.hasTopPadding;
  return hasTopPadding && css(["padding-top:", ";"], pxToRem(160));
}, media.md(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    grid-column: 1/5;\n    padding-top: ", ";\n    row-gap: ", ";\n    margin-bottom: ", ";\n  "])), pxToRem(320), getSpace('normal2'), getSpace('normal3')), media.lg(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    grid-column: 2/7;\n  "]))));
var ImageWrapDesktop = styled.div.withConfig({
  componentId: "sc-1tjh3df-2"
})(["justify-self:center;width:100%;grid-column:1/5;display:none;", " ", ""], media.md(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    display: grid;\n    align-content: ", ";\n    grid-column: 5/9;\n    margin-top: ", ";\n  "])), function (_ref3) {
  var imageAlign = _ref3.imageAlign;
  return imageAlign;
}, pxToRem(HEADER_HEIGHT_DESKTOP)), media.lg(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    grid-column: 7/13;\n  "]))));
var ImageHolderDesktop = styled.div.withConfig({
  componentId: "sc-1tjh3df-3"
})(["position:relative;height:", ";"], function (_ref4) {
  var imageHeight = _ref4.imageHeight;
  return pxToRem(imageHeight);
});
var ImageWrapMobile = styled.div.withConfig({
  componentId: "sc-1tjh3df-4"
})(["display:grid;grid-column:1/5;height:", ";margin:", " 0;position:relative;width:100%;", ""], function (_ref5) {
  var imageHeightMobile = _ref5.imageHeightMobile;
  return pxToRem(imageHeightMobile);
}, getSpace('medium2'), media.md(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    display: none;\n  "]))));
var ButtonWrapMobile = styled.div.withConfig({
  componentId: "sc-1tjh3df-5"
})(["margin-bottom:", ";display:flex;grid-column:1/5;", ""], getSpace('large3'), media.md(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    display: none;\n  "]))));
var ButtonWrapDesktop = styled.div.withConfig({
  componentId: "sc-1tjh3df-6"
})(["display:none;", ""], media.md(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n    display: flex;\n    align-self: top;\n    margin-bottom: ", ";\n  "])), getSpace('large3')));